import React, { useEffect, useState } from 'react'
import imageCompression from 'browser-image-compression';
import { getStorage,ref, uploadBytes,getDownloadURL } from "firebase/storage";
import {app} from "../api.js";

const storage = getStorage(app);

const FileUp = (props) => {


    const [upphoto, setupphoto] = useState(null);
// useEffect(() => {
//  setupphoto(props.x)
// }, [props.x])

const [Show, setShow] = useState(false)


const handlephoto = async(e) => {
  setShow(true)
  const file = e.target.files[0];
  const options = {
      maxSizeMB: 0.2,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    }
    try {

    const random = Math.floor(Math.random() * (1000000 - 1 + 1)) + 1;
        const ul = 'images/'+new Date()+random

      const compressedFile = await imageCompression(file, options);
    //   setmupphoto(compressedFile);
      const reader = new FileReader();
      reader.onload = () => {
          setupphoto(reader.result);
          uploadBytes(ref(storage, ul), compressedFile).then((snapshot) => {
            
            getDownloadURL(ref(storage, ul))
                .then((url) => {
                  console.log(url)
                  setShow(false)
                    props.setX(url);
                })
          });
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      console.log(error);
    }
};




  return (
    
    <div>
    <input style={{
  padding:10,
  width:'80%',
  margin:'5px 0px',
  border:'1px solid black'
}} accept="image/*" onChange={handlephoto} className="filestyle" type='file'/>
    {upphoto && <img src={upphoto} style={{width:200,height:110,margin:"10px 5px 10px 5px",borderRadius:10}} alt='img'/>}


{Show&&
<div style={{
    position:'fixed',
    top:0,
    bottom:0,
    right:0,
    left:0,
    backgroundColor:'white',
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    flexDirection:'column'
}}>
<span class="loader"></span>
<p style={{margin:0,padding:0,fontSize:12}}>Please Wait</p>
</div>}

    </div>
    
  )
}

export default FileUp
